// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EnqueueMemoExportMutationVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  memoId: Types.Scalars['ID']['input'];
  pathToPrint: Types.Scalars['String']['input'];
}>;


export type EnqueueMemoExportMutation = { __typename?: 'Mutation', enqueueMemoExportJob: { __typename?: 'WorkflowTracker', id: string } };

export type EnqueueMemoWordExportMutationVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  memoId: Types.Scalars['ID']['input'];
}>;


export type EnqueueMemoWordExportMutation = { __typename?: 'Mutation', enqueueMemoWordExport: { __typename?: 'WorkflowTracker', id: string } };

export const Operations = {
  Mutation: {
    EnqueueMemoExport: 'EnqueueMemoExport' as const,
    EnqueueMemoWordExport: 'EnqueueMemoWordExport' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const EnqueueMemoExportDocument = gql`
    mutation EnqueueMemoExport($householdId: ID!, $memoId: ID!, $pathToPrint: String!) {
  enqueueMemoExportJob(
    input: {householdID: $householdId, memoID: $memoId, relativePath: $pathToPrint}
  ) {
    id
  }
}
    `;
export type EnqueueMemoExportMutationFn = Apollo.MutationFunction<EnqueueMemoExportMutation, EnqueueMemoExportMutationVariables>;

/**
 * __useEnqueueMemoExportMutation__
 *
 * To run a mutation, you first call `useEnqueueMemoExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnqueueMemoExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enqueueMemoExportMutation, { data, loading, error }] = useEnqueueMemoExportMutation({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      memoId: // value for 'memoId'
 *      pathToPrint: // value for 'pathToPrint'
 *   },
 * });
 */
export function useEnqueueMemoExportMutation(baseOptions?: Apollo.MutationHookOptions<EnqueueMemoExportMutation, EnqueueMemoExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnqueueMemoExportMutation, EnqueueMemoExportMutationVariables>(EnqueueMemoExportDocument, options);
      }
export type EnqueueMemoExportMutationHookResult = ReturnType<typeof useEnqueueMemoExportMutation>;
export type EnqueueMemoExportMutationResult = Apollo.MutationResult<EnqueueMemoExportMutation>;
export type EnqueueMemoExportMutationOptions = Apollo.BaseMutationOptions<EnqueueMemoExportMutation, EnqueueMemoExportMutationVariables>;
export const EnqueueMemoWordExportDocument = gql`
    mutation EnqueueMemoWordExport($householdId: ID!, $memoId: ID!) {
  enqueueMemoWordExport(input: {householdID: $householdId, memoID: $memoId}) {
    id
  }
}
    `;
export type EnqueueMemoWordExportMutationFn = Apollo.MutationFunction<EnqueueMemoWordExportMutation, EnqueueMemoWordExportMutationVariables>;

/**
 * __useEnqueueMemoWordExportMutation__
 *
 * To run a mutation, you first call `useEnqueueMemoWordExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnqueueMemoWordExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enqueueMemoWordExportMutation, { data, loading, error }] = useEnqueueMemoWordExportMutation({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      memoId: // value for 'memoId'
 *   },
 * });
 */
export function useEnqueueMemoWordExportMutation(baseOptions?: Apollo.MutationHookOptions<EnqueueMemoWordExportMutation, EnqueueMemoWordExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnqueueMemoWordExportMutation, EnqueueMemoWordExportMutationVariables>(EnqueueMemoWordExportDocument, options);
      }
export type EnqueueMemoWordExportMutationHookResult = ReturnType<typeof useEnqueueMemoWordExportMutation>;
export type EnqueueMemoWordExportMutationResult = Apollo.MutationResult<EnqueueMemoWordExportMutation>;
export type EnqueueMemoWordExportMutationOptions = Apollo.BaseMutationOptions<EnqueueMemoWordExportMutation, EnqueueMemoWordExportMutationVariables>;